import { styled } from "@mui/material/styles";

import { ListItemButton, ListItemButtonProps } from "@mui/material";
import { ListItemIcon, ListItemIconProps } from "@mui/material";
import { ListItemText, ListItemTextProps } from "@mui/material";

interface InputListItemButtonProps extends ListItemButtonProps {
  active: number;
}

interface InputListItemIconProps extends ListItemIconProps {
  active: number;
}

interface InputListItemTextProps extends ListItemTextProps {
  active: number;
}
interface DotProps {
  active: number;
}

export const StyledListItemButton = styled(
  ListItemButton
)<InputListItemButtonProps>(({ theme, active }) => ({
  textDecoration: "none",
  "&:hover, &:focus": {
    backgroundColor: theme.palette.background.default,
  },
  // "& svg": {
  //   marginRight: 1,
  // },
  ...(active && {
    color: theme.palette.primary.main,
  }),
  color: theme.palette.text.primary,
}));

export const StyledListItemIcon = styled(ListItemIcon)<InputListItemIconProps>(
  ({ theme, active }) => ({
    marginRight: theme.spacing(1),
    color: theme.palette.secondary.main,
    "&:hover, &:focus": {
      color: theme.palette.primary.main,
    },
    ...(active && {
      color: theme.palette.primary.main,
    }),
    transition: theme.transitions.create("color"),
    minWidth: 64,
    display: "flex",
    justifyContent: "center",
  })
);

export const StyledListItemText = styled(ListItemText)<InputListItemTextProps>(
  ({ theme, active }) => ({
    padding: 0,
    color: theme.palette.primary.main,
    "&:hover, &:focus": {
      color: theme.palette.secondary.main,
    },
    ...(active && {
      color: theme.palette.secondary.main,
    }),
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 16,
  })
);

export const Dot = styled("div")<DotProps>(({ theme, active }) => ({
  width: 11,
  height: 11,
  backgroundColor: theme.palette.secondary.main,
  borderRadius: "50%",
  transition: theme.transitions.create("background-color"),
  "&:hover, &:focus": {
    backgroundColor: theme.palette.primary.main,
  },
  ...(active && {
    backgroundColor: theme.palette.primary.main,
  }),
}));
